import { defineMessages } from 'react-intl';

export default defineMessages({
  changeMarket: 'Change market',
  market: 'market',
});
